import React, { useEffect, useState } from 'react';
import http from '../../service'
import ItemPage from '../../Components/ItemPage';
import PlantingLotsIcon from '../../images/PlantingLotsIcon';
import * as S from './NewPlantingLot.style';
import * as constants from './NewPlantingLot.constants';
import { useParams, useHistory, useRouteMatch } from 'react-router-dom';

export default function PlantingLot({ setModal }) {
  const { id } = useParams();
  const history = useHistory();
  const { plantingLotFieldsState, plantingLotFields } = constants;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fields, setFields] = useState(plantingLotFieldsState);
  const itemFields = plantingLotFields({ fields });

  useEffect(() => {
    if (id) {
      http.get(`lot/${id}`)
        .then(({ data }) => setFields({
          greenery: { value: { value: data.data.greenery?.id, label: data.data.greenery?.name } },
          greenHouse: { value: { value: data.data.greenHouse?.id, label: data.data.greenHouse?.name } },
          stage: { value: { value: data.data.actualStage, label: data.data.actualStage } },
          seed: { value: { value: data.data.input.id, label: data.data.input.name } },
          sector: { value: { value: data.data.sector?.id, label: data.data.sector?.name } },
          stand: { value: { value: data.data.stand?.id, label: data.data.stand?.name } },
          amount: { value: data.data.plantQuantity },
          from: { value: new Date(data.data.plantDate) },
          comments: { value: data.data.description },
        }))
        .catch((err) => setModal({ isOpen: true, text: err.message }))

    }
  }, [id])

  const onSubmit = () => {
    http[id ? 'patch' : 'post'](`lot${id ? `/${id}` : ''}`, {
      greeneryId: fields.greenery.value.value,
      actualStage: fields.stage.value.value,
      inputId: fields.seed.value.value,
      plantQuantity: Number(fields.amount.value),
      plantDate: fields.from.value,
      standId: fields?.stand.value.value,
      sectorId: fields?.sector.value.value,
      greenhouseId: fields?.greenHouse?.value?.value,
      description: fields.comments.value,
    })
      .then(() => {
        setModal({ isOpen: true, text: 'Informações salvas com sucesso!', callBack: () => history.goBack() })
      })
      .catch((err) => {
        if (err?.response?.status === 400) {
          setModal({ isOpen: true, text: err.response.data.message })
        }
        else {
          setModal({ isOpen: true, text: err.message })
        }
      })
  }

  const itemPageObject = {
    ...constants, loading, error, fields: itemFields,
    setLoading, setError, icon: PlantingLotsIcon, setFields, onSubmit
  }

  return (
    <S.PlantingLots>
      <ItemPage {...itemPageObject} />
    </S.PlantingLots>
  );
};
